var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewArrow3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38983 27.6083H45.4068L31.4237 13.6175C30.1525 12.3456 30.1525 10.2258 31.4237 8.95392C32.6949 7.68203 34.8136 7.68203 36.0847 8.95392L55.1525 28.0323C56 28.8802 56 30.1521 56 31C56 31.8479 56 33.1198 55.1525 33.9677L36.0847 53.0461C34.8136 54.318 32.6949 54.318 31.4237 53.0461C30.1525 51.7742 30.1525 49.6544 31.4237 48.3825L45.4068 34.3917H9.38983C7.69492 34.3917 6 32.6959 6 31C6 29.3041 7.69492 27.6083 9.38983 27.6083Z",
    fill: "#FF7919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrow3);
export default __webpack_public_path__ + "static/media/newArrow3.e70e4c47619378a8cebc148be1ea33e5.svg";
export { ForwardRef as ReactComponent };